import { NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FeedbackService } from '@app/core/services/feedback.service';
import { AllowedExtensions, ExtendedFile, MaxFiles } from '@app/interfaces';
import { FileUploadDragAndDropDirective } from '../../directives/file-upload-dnd.directive';

export type Validator = (files: ExtendedFile[], component?: FileUploadDnDComponent) => ExtendedFile[];

export const filterByAllowedExtensions = (files: ExtendedFile[], component: AllowedExtensions): ExtendedFile[] => {
	if (!component.allowedExtensions || !component.allowedExtensions.length) {
		return files;
	}

	return files.filter((file) => component.allowedExtensions.indexOf(`.${file.name.split('.').pop()}`) > -1);
};

export const filterByMaxFiles = (files: ExtendedFile[], component: MaxFiles): ExtendedFile[] => {
	if (component.maxFiles && files.length > component.maxFiles) {
		files.splice(component.maxFiles - files.length);
	}
	return files;
};

export const defaultValidators = [filterByAllowedExtensions, filterByMaxFiles];

@Component({
    selector: 'sl-file-upload-dnd',
    templateUrl: './file-upload-dnd.component.html',
    standalone: true,
    imports: [
        NgClass,
        NgIf,
        FileUploadDragAndDropDirective,
        MatIconModule,
    ],
})
export class FileUploadDnDComponent implements OnChanges, OnInit, AllowedExtensions, MaxFiles {
	@Output() filesSelected = new EventEmitter<ExtendedFile[]>();
	@Input() allowedExtensions: string[] = [];
	@Input() defaultValidators = true;
	@Input() disabled = false;
	@Input() error: string;
	@Input() label: string | undefined = 'Upload File';
	@Input() maxFiles: number;
	@Input() validators: Validator[];
	@Input() helpText: string | undefined = '';
	multiple = false;
	uniqueId: string;
	wasWarned = false;

	constructor(private readonly feedbackService: FeedbackService) {
		this.uniqueId = `fileUpload${(Math.random() * 100).toFixed()}`;
	}

	ngOnChanges(): void {
		this.computeProps();
	}

	ngOnInit(): void {
		this.computeProps();
	}

	computeProps(): void {
		this.multiple = this.maxFiles ? this.maxFiles > 1 : true;
		this.validators = [].concat(this.defaultValidators ? defaultValidators : [], this.validators).filter((fn) => fn);
	}

	onFileDropped(fileList: FileList): void {
		this.filesSelected.emit(this.validate(Array.from(fileList)));
	}

	fileBrowseHandler(fileList: FileList): void {
		this.filesSelected.emit(this.validate(Array.from(fileList)));
	}

	validate(files: ExtendedFile[]): ExtendedFile[] {
		return this.validators.reduce((acc, validator) => validator(acc, this), files);
	}
}
